module.exports = __webpack_public_path__ + "img/logo_new.f20116ca.svg";